module.exports = __webpack_public_path__ + "img/searchBar.b0d8b05b.svg";